module.exports = {
	"A_BdE_homologated_company": "Sociedad Homologada por el Banco de España",
	"About_BARNATASA": "Sobre BARNA-TASA, S.A.",
	"About_text_01": "BARNA-TASA es una Sociedad de Tasación Homologada por el Banco de España, inscrita en el Registro Oficial de Entidades de Tasación con el nº 4.470 y fecha de inscripción 26 de junio de 1.995",
	"About_text_02": "La sociedad está formada por un grupo de arquitectos, ingenieros y especialistas en el campo de la valoración y tasación inmmobiliarias y un amplio conocimiento del sector, con más de 30 años de trayectoria",
	"About_us": "Sobre nosotros",
	"acc_Budget": "s/ Presupuesto",
	"acc_appraisal_date": "s/ fecha de tasación",
	"Actions": "Acciones",
	"Ad": "Anuncio",
	"Ads": "Anuncios",
	"Ad_address": "Dirección tal y como aparece en el anuncio",
	"Ad_code": "Código del anuncio",
	"Ad_database_query": "Consulta de anuncios en la base de datos",
	"Ad_data_type": "Tipo de datos",
	"Ad_date": "Fecha del anuncio",
	"Ad_type": "Tipo de anuncio",
	"Adaptability": "Adaptabilidad",
	"Add_address": "Añadir dirección",
	"Add_appraisal": "Añadir tasación",
	"Add_appraisal_file": "Añadir expediente de tasación",
	"Add_appraisal_report": "Añadir informe de tasación",
	"Add_contact": "Añadir contacto",
	"Add_email": "Añadir email",
	"Add_entity": "Añadir entidad",
	"Add_market_study": "Añadir estudio de mercado",
	"Add_real_estate": "Añadir inmueble",
	"Add_room": "Añadir estancia",
	"Add_telephone_number": "Añadir nº de teléfono",
	"Add_to_comparables_list": "Añadir a la lista de comparables",
	"Address": "Dirección",
	"Address_description": "Descripción de la dirección",
	"Addresses": "Direcciones",
	"Adjusted_Comparison_Method": "Método de Comparación Ajustado",
	"Adopted_age": "Antigüedad considerada",
	"Adopted_area": "Superficie adoptada",
	"Adopted_building_market_value": "Valor de mercado de la edificación adoptado",
	"Adopted_material_execution_cost": "Coste de ejecución material adoptado",
	"Adopted_material_execution_cost_deprecated_by_antiquity": "Coste de ejecución material adoptado depreciado por antigüedad",
	"Adopted_value": "Valor adoptado",
	"Age": "Antigüedad",
	"Agravation_or_improvement_coeficient": "Coeficiente de agravación o mejora",
	"Air_conditioning": "Aire acondicionado",
	"and": "y",
	"and_limit_date": "y la fecha límite",
	"annexes": "anexos",
	"Annexes": "Anexos",
	"Addressing_title": "Título de tratamiento",
	"Advertisements_between_starting_date": "Anuncios entre la fecha de inicio",
	"appraisal": "tasación",
	"Appraisal": "Tasación",
	"appraisal_company": "sociedad de tasación",
	"Appraisal_date": "Fecha de tasación",
	"appraisal_file": "expediente de tasación",
	"Appraisal_description": "Descripción de la tasación",
	"Appraisal_file": "Expediente de tasación",
	"Appraisal_files": "Expedientes de tasación",
	"Appraisal_file_description": "Descripción de expediente de tasación",
	"Appraisal_files_index": "Índice de expedientes de tasación",
	"Appraisal_petitioner": "Solicitante de tasación",
	"Appraisal_petitioners": "Solicitantes de tasación",
	"Appraisal_purpose": "Finalidad de la tasación",
	"appraisal_report": "informe de tasación",
	"Appraisal_report": "Informe de tasación",
	"Appraisal_report_description": "Descripción del informe de tasación",
	"Appraisal_reports": "Informes de tasación",
	"Appraisal_Requests": "Solicitudes de tasación",
	"Appraisal_total_value_determination": "Determinación del valor total de tasación",
	"Appraisal_type": "Tipo de tasación",
	"Appraisal_value": "Valor de tasación",
	"Appraisals": "Tasaciones",
	"Appraisals_for_all_purposes": "Tasaciones para todas las finalidades",
	"Appraisals_and_valuations": "Tasaciones y valoraciones",
	"Appraisals_Index": "Índice de Tasaciones",
	"Appraisals_of_the_Real_Estate": "Tasaciones del Inmueble",
	"Appraised": "Tasado",
	"Appraised_real_estates": "Inmuebles tasados",
	"Appraised_real_estates_in_this_report": "Inmuebles tasados en este informe",
	"Appraised_real_estate": "Inmueble tasado",
	"Appraiser": "Tasador",
	"Approximate_property_area": "Superfície aproximada del inmueble",
	"Area": "Superficie",
	"Areas": "Superficies",
	"areas": "superficies",
	"Are_you_sure_q": "Estás seguro?",
	"As_new_construction_cost": "Coste de construcción a nuevo",
	"Assets_value_update": "Actualización del valor de patrimonios",
	"Assurance": "Garantía",
	"at": "en",
	"Auditors": "Auditores",
	"average": "media",
	"Average": "Media",
	"Back_home": "Volver al inicio",
	"Bedrooms": "Dormitorios",
	"Building_Surveys": "Levantamientos de planos",
	"Back_to_safety": "Volver a un lugar seguro",
	"Bare_ownership": "Nuda propiedad",
	"Bare_ownership_value": "Valor de la nuda propiedad",
	"Barnatasa_cover_short_description": "Sociedad Especializada en Valoraciones y Tasaciones",
	"Barnatasa_header": "BARNA-TASA, S.A. Sociedad inscrita al Registro Oficial de Entidades de Tasación con el número 4.470. Fecha de inscripción en Banco de España: 26/06/1.995",
	"Barnatasa_footer": "Fin de página. Dorso no utilizable. Cualquier anotación en el mismo es nula y sin efecto.",
	"Barnatasa_header_portrait": "Sociedad inscrita en el Registro Oficial de Entidades de Tasación con el nº 4.460. Fecha de inscripción en Banco de España 26/06/1995. Reg. Merc. Barcelona, Folio 12, Tomo 28.173, Hoja B-132.666, NIF A-60840543",
	"Bathrooms": "Baños",
	"Bathrooms_number": "nº de Baños",
	"BdE_code": "código BdE",
	"Bedrooms_number": "nº de Dormitorios",
	"Block": "Bloque",
	"Budget_request": "Solicitud de presupuesto",
	"Builders_general_expenses_percentage": "Porcentaje de gastos generales del constructor",
	"Builders_general_expenses": "Gastos generales del constructor",
	"Builders_expenses_and_benefit_percentage": "Porcentaje de Gastos + Beneficio del constructor",
	"Builders_expenses_and_benefit": "Gastos + Beneficio del constructor",
	"Builders_industrial_benefit_percentage": "Porcentaje del Beneficio industrial tipo del constructor",
	"Builders_industrial_benefit": "Beneficio industrial del constructor",
	"Building_market_value": "Valor de mercado de la edificación",
	"real_estate_under_construction": "inmueble en construcción",
	"Buildings": "Edificios",
	"Buildings_useful_life": "Vida útil del edificio",
	"Built_area": "Superficie construida",
	"by": "por",
	"By": "Por",
	"Cadastral_area": "Superficie Catastral",
	"Cadastral_data_check": "Comprobación catastro",
	"Cadastral_data": "Datos catastrales",
	"Cadastral_List": "Listado del Catastro",
	"Cadastral_Map": "Mapa del Catastro",
	"Cadastral_reference": "Referencia catastral",
	"Cadastral_Reference_less_20_positions_error_text": "La Referencia Catastral tiene menos de 20 posiciones",
	"Calculate_values": "Calcular valores",
	"Calendar": "Calendario",
	"Cancel": "Cancelar",
	"Capture_date": "Fecha de captura",
	"Census_section": "Sección censal",
	"Census_section_code": "Código de sección censal",
	"Catalan": "Catalán",
	"certificates": "certificados",
	"cession": "cesión",
	"Cession": "Cesión",
	"Cession_contract_period_years": "Duración del contrato (años)",
	"Cession_contract_remaining_years": "Años restantes de contrato",
	"Cession_contract_start_date": "Fecha de inicio del contrato",
	"Cession_gross_monthly_income": "Renta bruta mensual del contrato",
	"Cession_gross_yearly_income": "Renta bruta anual del contrato",
	"Cession_net_yearly_income": "Renta neta anual",
	"Changes_will_be_lost_p_continue_q": "Se perderán los cambios. ¿Continuar?",
	"Checks": "Comprobaciones",
	"Checks_performed": "Comprobaciones realizadas",
	"Code": "Código",
	"Clients_text_01": "BARNA-TASA, S.A. cuenta con una amplia cartera de clientes y trabaja con todo tipo de clientes del ámbito privado y público. De los que destacamos",
	"Clients_text_02": "BARNA-TASA S.A. ofrece una amplia gama de servicios destinados a ayudar en la toma de decisiones relativas a la valoración y comprobación del estado de inmuebles y otros bienes",
	"Clients_text_03": "El objetivo de BARNA-TASA S.A. es apoyar a los clientes de las mejores firmas de abogados y auditoras nacionales e internacionales, en aquellas operaciones que requieran una valoración inmobiliaria. Desde una valoración para un proceso de expropiación, hasta las valoraciones necesarias en operaciones de fusión y adquisición, asesoramiento en desinversión de activos y reestructuraciones, abarcando además cualquier sector",
	"Clients_text_04": "Un entorno empresarial como el actual genera a las empresas la necesidad de acometer proyectos complejos y, a la vez, decisivos en su día a día. Conocedora de esta circunstancia, BARNA-TASA S.A. pone su experiencia, profesionalidad y conocimiento del mercado, a disposición de pequeñas-grandes empresas y entidades financieras en un amplio abanico de servicios, garantizando un trato personalizado y profesional",
	"closed": "cerrado",
	"Commercial_premises": "Locales comerciales",
	"Commission": "Encargo",
	"Commitment": "Compromiso",
	"Company_code": "Código de Sociedad",
	"Company_or_business_name": "Empresa o razón social",
	"Comparable_type": "Tipo de comparable",
	"Comparable_database_query": "Consulta de comprables en la base de datos",
	"comparables": "comparables",
	"Comparables": "Comparables",
	"Comparison_Method": "Método de Comparación",
	"Confidentiality": "Confidencialidad",
	"Confirm_Password": "Confirmar Contraseña",
	"Constant_income_with_CPI_update_clause": "Renta constante con cláusula de actualización del IPC",
	"Conservation": "Conservación",
	"Conservation_status": "Estado de conservación",
	"construction": "construcción",
	"Construction": "Construcción",
	"Construction_cost": "Coste de construcción",
	"Construction_cost_and_development_expenses": "Coste de construcción y gastos de promoción",
	"Construction_cost_by_contract": "Coste de construcción por contrata",
	"Construction_costs": "Costes de construcción",
	"Construction_progress_percentage": "Porcentaje de construcción realizada",
	"Construction_replacement_cost": "Coste de reposición de la construcción",
	"Construction_value": "Valor de la construcción",
	"construction_year": "año de construcción",
	"Construction_year": "Año de construcción",
	"Contact": "Contacto",
	"Contact_data": "Datos de contacto",
	"Contact_Data": "Datos del Contacto",
	"Contact_file": "Ficha del contacto",
	"Contact_name": "Nombre del contacto",
	"Contact_telephone": "Teléfono de contacto",
	"Contacts": "Contactos",
	"Contacts_Index": "Índice de Contactos",
	"contained_in_this_file": "contenidos en este expediente",
	"contained_in_this_file_f": "contenidas en este expediente",
	"Continue_q": "Continuar?",
	"Contracts_foreseeable_remaining_period": "Duración restante previsible de contrato",
	"Cooperatives": "Cooperativas",
	"Corrected_market_value": "Valor de mercado corregido",
	"Corrected_unit_market_value": "Valor unitario corregido",
	"Correction": "Corrección",
	"Correction_of_values": "Corrección de valores",
	"Cost_method": "Método del coste",
	"Council_classification": "Clasificación Ayuntamiento",
	"Council_classification_description": "Descripción Clasificación Ayuntamiento",
	"Council_qualification": "Calificación Ayuntamiento",
	"Council_qualification_description": "Descripción Calificación Ayuntamiento",
	"Regional_classification": "Clasificación MUC",
	"Regional_classification_description": "Descripción Clasificación MUC",
	"Regional_qualification": "Calificación MUC",
	"Regional_qualification_description": "Descripción Calificación MUC",
	"Country": "País",
	"Country_s_State": "País / Estado",
	"Covered_outdoor_area": "Superficies exteriores cubiertas",
	"Create_a_new_contact": "Crear un nuevo contacto",
	"Created": "Creado",
	"Creation": "Creación",
	"Current_reversion_value_calculation": "Cálculo del valor actual de reversión",
	"Current_value_of_future_rents": "Valor actual de rentas futuras",
	"Customer_Service": "Servicio de Atención al Cliente",
	"Customer_Service_text_01": "pone a disposición de sus clientes su",
	"Customer_Service_text_02": "al que estos pueden dirigir tanto las quejas, sugerencias y reclamaciones relacionadas con el servicio prestado por la Sociedad",
	"Customer_Service_text_03": "Las funciones del SAC son",
	"Customer_Service_text_04": "Atender y resolver las quejas, reclamaciones y consultas presentadas, directa o mediante representación, por personas físicas o jurídicas, españolas o extranjeras clientes de la Sociedad, cuando las mismas se refieran a intereses o derechos legalmente reconocidos relacionados con operaciones, contratos o servicios prestados por la empresa, ya deriven de los propios contratos, de la normativa de transparencia y protección de la clientela o de las buenas prácticas y usos, en particular del principio de equidad",
	"Customer_Service_text_05": "Hacer llegar a la dirección  de la empresa las recomendaciones y sugerencias sobre todos aquellos aspectos que, en su opinión, supongan un fortalecimiento de las buenas relaciones y mutua confianza que deben existir entre la empresa y sus clientes",
	"Customer_Service_text_06": "Los deberes de información de este SAC quedan recogidas en la vigente legislación Orden ECO/734/2004, de 11 de marzo, sobre los departamentos y servicios de atención al cliente de las entidades financieras",
	"Customer_Service_text_07": "Acceso al Reglamento del Servicio de Atención al Cliente de BARNA-TASA, S.A.",
	"Customer_Service_text_08": "Acceso a la hoja de reclamaciones",
	"Customer_Service_text_09": "Legislación aplicable para la defensa del cliente de servicios financieros",
	"Customer_Service_text_10": "Ley 2/2011 de 4 de marzo de Economía Sostenible",
	"Customer_Service_text_11": "Orden ECC/2502/2012 de 16 de noviembre, por la que se regula el procedimiento de presentación de reclamaciones ante los servicios de reclamaciones del Banco de España, la Comisión Nacional del Mercado de Valores y la Dirección General de Seguros y Fondos de Pensiones",
	"Customer_Service_text_12": "Orden ECO/734/2004. De 11 de marzo, sobre los departamentos y servicios de atención al cliente y el defensor del cliente de las entidades financieras",
	"Customer_Service_text_13": "Puede contactar con nosotros a través de los siguientes medios",
	"Customer_Service_text_14": "En persona, en la oficina de atención al público del Servicio de Atención al Cliente (de 10h a 13h y de 16h a 19h). Dirección",
	"Customer_Service_text_15": "Por correo certificado dirigido a",
	"Customer_Service_text_16": "Ponemos a disposición de los clientes un formulario de quejas y reclamaciones, que encontrará en este",
	"Customer_Service_text_17": "El formulario es de carácter voluntario y contendrá la siguiente información",
	"Customer_Service_text_18": "Nombre y apellidos del interesado",
	"Customer_Service_text_19": "Domicilio del interesado (y en su caso de la persona que lo represente)",
	"Customer_Service_text_20": "Para personas físicas: el NIF del interesado",
	"Customer_Service_text_21": "Para personas jurídicas: el CIF y los datos referidos al registro mercantil",
	"Customer_Service_text_22": "Motivo de la queja, especificando claramente las cuestiones sobre las que se solicita un pronunciamiento",
	"Customer_Service_text_23": "Appraisal file Nº",
	"Customer_Service_text_24": "Lugar, fecha y firma",
	"Customer_Service_text_25": "Pruebas documentales (en su caso)",
	"Customer_Service_text_26": "En el caso de haber agotado las vías a través del Departamento de Atención al Cliente( haberse denegado, desestimado o haber transcurrido más de dos meses sin resolución), se podrá interponer reclamación ante el Departamento de Conducta de Mercado y Reclamaciones cuyos datos de contacto son",
	"Customer_Service_text_27": "O por vía telemática a través de la Oficina Virtual",
	"Data": "Datos",
	"Data_tabulation": "Tabulación de datos",
	"date": "fecha",
	"Date": "Fecha",
	"Data_of_property_to_be_appraised": "Datos del inmueble a tasar",
	"Date_of_the_appraisal_value": "Fecha del valor de tasación",
	"Date_of_report": "Fecha del informe",
	"Date_of_quote": "Fecha del presupuesto",
	"Date_of_invoice": "Fecha de la factura",
	"Delete": "Eliminar",
	"Deprecated_construction_cost": "Coste de construcción depreciado",
	"Depreciation_by_antiquity": "Depreciación por antigüedad",
	"description": "description",
	"Description": "Descripción",
	"Discard": "Descartar",
	"Distance": "Distancia",
	"Door": "Puerta",
	"Duplicate": "Duplicar",
	"Dwellings": "Viviendas",
	"Dwelling_type": "Tipo de vivienda",
	"e-mail": "correo electrónico",
	"E-mail": "Correo electrónico",
	"E-mail_address": "Dirección de correo electrónico",
	"E-mail_addresses": "Direcciones de correo electrónico",
	"E-mail_description": "Descripción del correo electrónico",
	"Email": "Correo electrónico",
	"Email address": "Dirección de correo electrónico",
	"Edit_ad": "Editar anuncio",
	"Edit": "Editar",
	"Edit_address": "Editar dirección",
	"Edit_Appraisal": "Editar tasación",
	"Edit_real_estate": "Editar inmueble",
	"Edit_Real_Estate": "Editar Inmueble",
	"Edit_contact": "Editar contacto",
	"Email_Address": "Dirección de Correo Electrónico",
	"Energy_Certificates": "Certificados Energéticos",
	"Energy_Efficiency_Certificate": "Certificado de Eficiencia Energética",
	"Entities": "Entidades",
	"Entities_Index": "Índice de Entidades",
	"Entity": "Entidad",
	"EPSG_missing_text": "Faltan las cordenadas X e Y EPSG:25831 para poder obtener la referencia catastral y el código de sección censal. Se pueden consultar con el botón de Geolocalizar",
	"Estimated_sale_price": "Precio de venta estimado",
	"Estimated_unit_sale_price": "Precio unitario estimado",
	"Estimated_useful_life": "Vida útil estimada",
	"Executed_construction_cost": "Coste de construcción realizada",
	"Expected_Income_Update_Method": "Método Actualización de Renta Esperada",
	"Experience": "Experiencia",
	"Experience_text": "Más de 30 años de trayectoria ofreciendo el mejor servicio al mejor precio",
	"Expert_Opinions": "Dictámenes Periciales",
	"expert_opinions": "dictámenes periciales",
	"Expropriations": "Expropiaciones",
	"External_storage_room": "Trastero",
	"features": "características",
	"Features": "Características",
	"Fees": "Honorarios",
	"file": "expediente",
	"File": "Expediente",
	"File_description": "Descripción del expediente",
	"Files": "Expedientes",
	"File_number": "Nº de expediente",
	"Final_unit_price": "Precio unitario final",
	"Fiscal_Address": "Dirección Fiscal",
	"Fiscal_address": "Dirección fiscal",
	"Floor": "Planta",
	"Floor_number": "Nº Planta",
	"Floor_type": "Tipo de planta",
	"Financial_Entities": "Entidades Financieras",
	"finished_real_estate": "inmueble terminado",
	"finishes": "acabados",
	"Finishes": "Acabados",
	"fixtures": "instalaciones",
	"Fixtures": "Instalaciones",
	"For_all_purposes": "Para todas las finalidades",
	"Foundations": "Fundaciones",
	"Freemarket_benefit": "Beneficio mercado libre",
	"Fri.": "Vie.",
	"from": "de",
	"Functional_depreciation": "Depreciación funcional",
	"General_data": "Datos generales",
	"Green_areas": "Jardín / Zonas ajardinadas",
	"from_the_excess_of": "del exceso de",
	"Have_an_account_q_Log_in": "Ya tienes una cuenta? Inicia sesión",
	"Heating": "Calefacción",
	"Height_situation": "Situación en altura",
	"Higher_values": "Valores superiores",
	"Home_text_01": "Sociedad de tasación homologada, desde 1995, en el Registro Oficial de Entidades de Tasación del Banco de España",
	"homogenisation": "homogeneización",
	"Homogenisation": "Homogeneización",
	"Homogenisation_of_values": "Homogeneización de valores",
	"Homologated_company": "Sociedad homologada",
	"Homologated_Appraisal_Company_c_since_1995": "Sociedad de Tasación Homologada, desde 1995",
	"Homologated_text_01_part01": "Inscrita en el",
	"Homologated_text_01_part02": "de Entidades de Tasación del Banco de España, con nº 4.470 y fecha 26/06/1.995",
	"Honorarium_c_taxes_and_licenses": "Honorarios facultativos, tasas y licencias",
	"Honorarium_c_taxes_and_licenses_percentage": "Porcentaje de honorarios facultativos, tasas y licencias",
	"Hospitals": "Hospitales",
	"Hotels": "Hoteles",
	"Decennial_insurance_policy_expenses": "Gastos de póliza de seguro decenal",
	"Decennial_insurance_policy_expenses_percentage": "Porcentaje de gastos de póliza de seguro decenal",
	"Developers_administrative_expenses": "Gastos administrativos del promotor",
	"Developers_administrative_expenses_percentage": "Porcentaje de gastos administrativos del promotor",
	"Developers_benefit": "Beneficio del promotor",
	"Development_expenses": "Gastos de promoción",
	"Development_expenses_percentage": "Porcentaje de gastos de promoción",
	"Geographical_area": "Ámbito geográfico",
	"Geolocate": "Geolocalizar",
	"Identification": "Identificación",
	"go_back": "volver atrás",
	"Go_back": "Volver atrás",
	"go_up": "volver arriba",
	"Go_up": "volver arriba",
	"Gross_Replacement_Cost": "Coste de Reemplazamiento-reposición Bruto",
	"Gross_yearly_rent_income": "Renta bruta anual de alquiler",
	"Geolocation": "Geolocalización",
	"in_01": "en",
	"In_accordance_with_eco_decree_q": "¿s/ Orden ECO?",
	"In_accordance_with_mortgage_market_law_q": "¿s/ Ley Mercado Hipotecario?",
	"Independence": "Independencia",
	"Independent_professionals": "Profesionales independientes",
	"Independent_pl": "Independientes",
	"Index_of_Appraisals": "Índice de Tasaciones",
	"Individuals": "Particulars",
	"Industrial_warehouses": "Naves industriales",
	"Info_source": "Fuente de la información",
	"Informative_Appraisal_Fees": "Honorarios Tasación Informativa",
	"Infrastructures": "Infraestructuras",
	"Paving_execution_pct": "Porcentaje de ejecución de pavimentación",
	"Sewage_execution_pct": "Porcentaje de ejecución de alcantarillado",
	"Public_lighting_execution_pct": "Porcentaje de ejecución de alumbrado público",
	"Water_supply_execution_pct": "Porcentaje de ejecución de suministro de agua",
	"Electricity_supply_execution_pct": "Porcentaje de ejecución de suministo eléctrico",
	"Piped_gas_execution_pct": "Porcentaje de ejecución de gas canalizado",
	"Telephone_service_execution_pct": "Porcentaje de ejecución de servicio telefónico",
	"Gardened_areas_execution_pct": "Porcentaje de ejecución de zonas ajardinadas",
	"Total_execution_pct": "Porcentaje de ejecución total infraestructuras",
	"Infrastructures_repercussion_cost": "Coste de repercusión infraestructuras",
	"Pending_investment": "Inversión pendiente",
	"Paving": "Pavimentación",
	"Sewage": "Alcantarillado",
	"Public_lighting": "Alumbrado público",
	"Electricity_supply": "Suministro electricidad",
	"Piped_gas": "Gas canalizado",
	"Telephone_service": "Servicio telefónico",
	"Gardened_areas": "Zonas ajardinadas",
	"Land_is_plot_according_to_law": "¿Tiene el terreno consideración de solar según la Ley del Suelo?",
	"Notes_on_plot_infrastructures": "Observaciones sobre las infraestructuras",
	"Notes_on_plot_area": "Observaciones sobre la superficie del terreno",
	"Initial_Data": "Datos Iniciales",
	"Initial_unit_price": "Precio unitario inicial",
	"Innovation": "Innovación",
	"Insurance_companies": "Compañías de seguros",
	"Insurance_value": "Valor del seguro",
	"Interior_visit_check": "Visita interior",
	"Internal_regulation": "Reglamento interno",
	"Invalid_email_address": "La dirección de e-mail es incorrecta",
	"Investment_groups": "Grupos de inversión",
	"Invoices": "Facturas",
	"Is_it_rented_or_ceded_q": "¿El inmueble está alquilado o cedido?",
	"Is_the_real_estate_protected_q": "Está el inmueble protegido?",
	"Is_the_right_of_use_ceded_q": "El derecho de uso del inmueble está cedido?",
	"land": "suelo",
	"Land": "Suelo",
	"Land_area": "Superficie de terreno",
	"Land_registry_area": "Superficie registral del terreno",
	"Land_market_value": "Valor de mercado del suelo",
	"Land_pl": "Terrenos",
	"Land_total_value": "Valor total del suelo",
	"Land_value": "Valor del suelo",
	"Land_value_plus_deprecated_construction_cost": "Valor del suelo más coste de construcción depreciado",
	"Land_value_plus_executed_construction_cost": "Valor del suelo más coste de construcción realizada",
	"Landlord_expenses_pct": "Porcentaje neto restante debido a gastos del arrendador",
	"Language": "Idioma",
	"Last_modified": "Última modificación",
	"last_renovation_year": "Último año de rehabilitación",
	"Last_renovation_year": "Último año de rehabilitación integral",
	"Latitude": "Latitud",
	"Appraisal_adopted_area_missing_error_text": "Es necesario introducir la superficie construida del inmueble de referencia para poder proceder con el estudio de mercado",
	"Appraisal_property_type_missing_error_text": "Es necesario introducir el tipo de inmueble correspondiente al inmueble de referencia para poder realizar la consulta",
	"Lat_lng_missing_error_text": "Es necesario introducir las coordenadas de latitud y longitud para el inmueble actual",
	"Ad_type_missing_error_text": "Es necesario introducir el tipo de anuncio que se quiere obtener para poder realizar la consulta",
	"Date_missing_error_text": "Es necesario introdcir el rango de fechas (inicio y final) para poder consultar los anuncios",
	"Adopted_age_missing_error_text": "Es necesario introducir la antigüedad adoptada para poder proseguir",
	"Adopted_age_length_error_text": "La antigüedad adoptada tiene que ser un año, con formato 'YYYY'",
	"Adopted_area_missing_error_text": "Es necesario introducir la superficie construida para poder proseguir",
	"Property_type_missing_error_text": "Es necesario introducir el tipo de inmueble para poder proseguir",
	"Law_firms": "Despachos jurídicos",
	"Lift": "Ascensor",
	"link": "enlace",
	"Loading": "Cargando",
	"Log_In": "Iniciar sesión",
	"Longitude": "Longitud",
	"Looking_for_something_q": "Buscando algo?",
	"Lower_limit": "Límite inferior",
	"Machinery": "Maquinaria",
	"Market_coeficient": "Coeficiente de mercado",
	"Market_value_adjustment": "Ajuste del valor de mercado",
	"Market_value_of_the_appraised_realestate": "Valor de mercado del inmueble tasado",
	"Market": "Mercado",
	"Market_calculations": "Cálculos del mercado",
	"Market_studies_for_this_real_estate": "Estudios de mercado para este inmueble",
	"Market_study": "Estudio de mercado",
	"Market_study_for": "Estudio de mercado para",
	"Market_value_reduction_pct": "Reducción valor mercado (%)",
	"Market_studies": "Estudios de mercado",
	"Material_execution_cost": "Coste de ejecución material",
	"Market_unit_value": "Valor unitario de mercado",
	"Market_value": "Valor de mercado",
	"Maximum_Legal_Method": "Método Máximo Legal",
	"Mec_adjustment_coef": "Coeficiente de ajuste del coste de ejecución material",
	"Materials": "Materiales",
	"Maximum_legal_computable_area": "Superfície legal máxima computable",
	"Maximum_legal_sale_price": "Precio de venta máximo legal",
	"Measurements": "Mediciones",
	"Medical_centers": "Centros médicos",
	"Messages": "Mensajes",
	"Metadata": "Metadatos",
	"Minimum_benefit_acc_to_regulation": "Beneficio mínimo según la norma",
	"Minimum_fees": "Honorarios mínimos",
	"Modification": "Modificación",
	"Modified": "Modificado",
	"Mon.": "Lun.",
	"Mortgage_Appraisal_Fees": "Honorarios Tasación Hipotecaria",
	"Municipality": "Municipio",
	"Mutual_insurance_companies": "Mutuas",
	"Name": "Nombre",
	"Name_and_surnames": "Nombre y apellidos",
	"Name_and_TIN": "Nombre y NIF/CIF",
	"net_area": "superficie útil",
	"Net_area": "Superficie útil",
	"Net_areas": "Superficies útiles",
	"Net_Replacement_Cost": "Coste de Reemplazamiento-reposición Neto",
	"Net_yearly_rent_income": "Renta neta anual de alquiler",
	"New_address": "Nueva dirección",
	"New_appraisal_file": "Nuevo expediente de tasación",
	"New_contact": "Contacto nuevo",
	"New_entity": "Nueva entidad",
	"Number": "Número",
	"Number_of_floors_and_use": "Nº de plantas y uso",
	"No_address_registered": "Ninguna dirección registrada",
	"No_contact_registered": "Ningún contacto registrado",
	"No_email_address_registered": "Ningúna dirección de correo electrónico registrada",
	"No_telephone_number_registered": "Ningún nº de teléfono registrado",
	"No_results": "Ningún resultado",
	"Non_recoverable_taxes": "Impuestos no recuperables",
	"Non_recoverable_taxes_percentage": "Porcentaje de impuestos no recuperables",
	"Not_found_message": "Página no encontrada",
	"notes": "observaciones",
	"Notes": "Observaciones",
	"Notes_1": "Observaciones 1",
	"Notes_2": "Observaciones 2",
	"Notes_on_mortgage_valuation_validity": "Observaciones sobre la validez de la tasación para fines hipotecarios",
	"Occupancy_Card": "Cédula de habitabilidad",
	"Occupancy_Cards": "Cédulas de habitabilidad",
	"Occupancy_Card_and_Certificate": "Certificado y Cédula de Habitabilidad",
	"Occupancy_Certificate": "Certificado de habilidad",
	"occupancy_certificates": "cèdulas de habitabilidad",
	"of": "de",
	"of_the_excess_of": "del exceso de",
	"of_the_same_property": "del mismo inmueble",
	"Offer_price": "Precio de la oferta",
	"Offer_unit_price": "Precio unitario de la oferta",
	"Official_Appraisals": "Tasaciones Oficiales",
	"Official_appraisals_for_all_purposes": "Tasaciones oficiales para toda finalidad",
	"Office_hours": "Horario de oficinas",
	"Official_Register": "Registro Oficial",
	"Offices": "Oficinas",
	"Open": "Abrir",
	"Open_link_in_new_tab": "Abrir link en una nueva pestaña",
	"Organization_s_Company": "Organización / Empresa",
	"Orientation": "Orientación",
	"Other_services": "Otros servicios",
	"other_services": "otros servicios",
	"others": "others",
	"Other_elements_included_in_this_valuation_price": "Otros elementos incluidos en esta valoración",
	"Our_clients": "Nuestros clientes",
	"Our_services": "Nuestros servicios",
	"Our_workflow": "Nuestro flujo de trabajo",
	"PA_registration_number": "Nº colegiado",
	"Page_not_found": "Página no encontrada",
	"Parking_lots_number": "nº Plazas de garaje",
	"Parking_spaces": "Plazas de garaje",
	"Password": "Contraseña",
	"Person_type": "Tipo de persona",
	"Petitioner": "Solicitante",
	"Petitioner_data": "Datos del solicitante",
	"Petitioner_type": "Tipo de solicitante",
	"Philosophy": "Filosofía",
	"Philosophy_text_01": "La filosofía de la sociedad se puede resumir en tres principios fundamentales: profesionalidad, rapidez y ética. Todo ello unido a un buen equipo de profesionales y a un control de calidad exhaustivo",
	"Philosophy_text_02": "Para BARNA-TASA, S.A. los valores definen nuestra identidad como empresa y constituyen la fuerza propulsora del cómo hacemos día a día nuestro trabajo. Consideramos que nuestro éxito es consecuencia de los mismos, entre los que destacamos",
	"Philosophy_text_03": "Auditoría continua de nuestros procesos de realización de tasaciones y valoraciones unido al empleo de las últimas tecnologías. BARNA-TASA, S.A. dispone de software especialmente desarrollado para el ejercicio de la valoración empleando las herramientas informáticas más adecuadas. Todos nuestros informes incorporan certificación de firma digital",
	"Philosophy_text_04": "Es una sociedad cuyo accionariado y junta directiva es privado y NO VINCULADO a ninguna Entidad Financiera ni grupo immobiliario. BARNA-TASA, S. A. no intermedia en operaciones de compraventa en el mercado, por lo que sus servicios se prestan des de la más absoluta independencia",
	"Philosophy_text_05": "Capacidad de respuesta contrastada, efectividad y equilibrio de nuestras valoraciones. Compromiso de cumplir los requisitos y procesos necesarios para la satisfacción del cliente",
	"Philosophy_text_06": "Nuestro sistema de calidad se basa en los siguientes principios: La mejora continua y superación como objetivo permanente, lo cual se consigue especialmente a través del compromiso de toda la organización y del análisis sistemático de los resultados de calidad. Satisfacer las necesidades y expectativas de los clientes, cumpliendo los tiempos de entrega acordados con los clientes y trabajando en la mejora de los mismos, entregando siempre un buen producto a la primera. El cumplimiento de los requisitos, ya sean reglamentarios y legales, particulares de nuestros clientes o de cualquier otra índole, dando así respuesta a todas las partes interesadas",
	"Philosophy_text_07": "Asegurar el cumplimiento de la normativa vigente y el trabajo bien hecho",
	"Philosophy_text_08": "El hecho de estar homologados e inscritos con el número 4.470 en el Registro de Sociedades de Tasación del Banco de España y estar sujetos a la supervisión, garantiza el rigor la objetividad y la transparencia absoluta de nuestros informes de valoración",
	"Philosophy_text_09": "Más de tres décadas en el campo de la tasación avalan nuestro trabajo",
	"Philosophy_text_10": "La confidencialidad de los trabajos que la normativa exige, está garantizada por el secreto profesional que rige la conducta de nuestros técnicos. BARNA-TASA S.A. no revela información a terceras personas",
	"Philosophy_text_11": "BARNA-TASA, S. A. establece un marco de conducta para la sociedad y sus trabajadores",
	"Physical_depreciation": "Depreciación física",
	"Pick_an_option": "Selecciona una opción",
	"Plan_type": "Tipo de plan",
	"Please_enter_a_name": "Por favor, introduzca un nombre",
	"Please_enter_a_surname": "Por favor, introduzca un apellido",
	"Please_enter_a_telephone_number": "Por favor, introduzca un número de teléfono",
	"Please_enter_an_email_address": "Por favor, introduzca una dirección de correo electrónico",
	"Please_enter_the_type_of_property": "Por favor, introduzca el tipo de inmueble a tasar",
	"Please_enter_the_address_of_the_property": "Por favor, introduzca la dirección del inmueble",
	"Please_enter_the_postal_code": "Por favor, intoruzca el código postal del inmueble",
	"Please_enter_the_municipality": "Por favor, introduzca el municipio",
	"Please_enter_the_area_of_the_property": "Por favor, introduzca la superficie del inmueble",
	"Please_enter_the_purpose_of_the_appraisal": "Por favor, introduzca la finalidad de la tasación",
	"Plot_area": "Superficie del solar",
	"Postal_code": "Código postal",
	"Prefix": "Prefijo",
	"Price": "Precio",
	"Pricing": "Tarifas",
	"Pricing_and_Quotes": "Tarifas y Presupuesto",
	"Pricing_text_01": "Ofrecemos dos tipos de valoraciones: la valoración hipotecaria y la valoración informativa, según su finalidad",
	"Pricing_text_02": "Obtendrá en un plazo máximo de 24h el presupuesto por escrito de su tasación, sin compromiso",
	"Pricing_text_03": "Descuento por volumen de encargo. IVA APLICABLE: 21%",
	"Pricing_text_04": "Tasación hipotecaria: Regulada por la normativa ECO 805/2003 y disposiciones concordantes",
	"Pricing_text_05": "Las localidades fuera de Barcelona capital y área metropolitana tendrán incremento por desplazamiento",
	"Pricing_text_06": "Descuento especial para los pedidos de Informe de Tasación + Certificado de un mismo inmueble",
	"Print_report_in_PDF": "Imprimir informe en PDF",
	"Private_Enterprises": "Empresas Privadas",
	"Professional_association": "Colegio profesional",
	"Professional_ethics": "Ética profesional",
	"Professional_qualification": "Titulación",
	"Professionalism": "Profesionalidad",
	"Professionals_text_01_part_01": "Una sociedad de",
	"Professionals_text_01_part_02": "arquitectos, ingenieros y especialistas totalmente independientes",
	"Professionals_text_01_part_03": ", sin vinculación con entidades financieras ni grupos empresariales",
	"Properties": "Inmuebles",
	"Properties_under_economic_exploitation": "Inmuebles en explotación económica",
	"Property_data": "Datos del inmueble",
	"Property_developers": "Promotores inmobiliarios",
	"Property_developments": "Promociones inmobiliarias",
	"Property_purchase-sale": "Compraventa de inmuebles",
	"Property_type": "Tipo de inmueble",
	"Property_types": "Tipos de inmuebles",
	"Property_valuation_services": "Servicios de valoración inmobiliaria",
	"Property_visit": "Visita al inmueble",
	"protection": "protección",
	"Protection": "Protección",
	"Protection_type": "Tipo de protección",
	"Protection_regime": "Régimen de protección",
	"Protection_zone": "Zona de protección",
	"Province": "Provincia",
	"Public_Administrations": "Administraciones públicas",
	"purpose": "finalidad",
	"Qualities": "Calidades",
	"Qualities_comparison": "Comparación de calidades",
	"Quality": "Calidad",
	"Quality_of_construction": "Calidad de la construcción",
	"Quality_of_neighbourhood": "Calidad del barrio",
	"Quality_of_realestate": "Calidad del elemento",
	"Quality_of_situation": "Calidad de la situación",
	"Query_comparables": "Consultar comparables",
	"Query_real_estates": "Consultar inmuebles",
	"Query_result": "Resultado de la consulta",
	"Quote_request": "Solicitud de presupuesto",
	"Quotes": "Presupuestos",
	"Real_estate": "Inmueble",
	"Real_estates": "Inmuebles",
	"Real_estates_index": "Índice de inmuebles",
	"Real_estate_referral": "Inmueble de referencia",
	"Realestates_remaining_useful_life": "Vida útil restante del inmueble",
	"Real_estates_residual_value_at_the_end_of_the_contracts_useful_life": "Valor residual del inmueble al final de la vida útil del contrato",
	"Real_estate_value": "Valor del inmueble",
	"RealEstate_description": "Descripción del inmueble",
	"Reduction": "Reducción",
	"Reduction_pct": "Reducción (%)",
	"Registry_data": "Datos registrales",
	"Registry_identification_data": "Identificación registral",
	"Register_name": "Nombre del Registro",
	"Regression_line": "Línea de regresión",
	"Regression_line_calculation": "Cálculo de la línea de regresión",
	"Remaining_contract_years": "Años restantes de contrato",
	"Remaining_period_update": "Actualización del período restante",
	"Remaining_of_the_developers_benefit": "Restante del beneficio del promotor",
	"Repercussion_method": "Método de repercusión",
	"Report": "Informe",
	"reports": "informes",
	"Report_content": "Contenido del informe",
	"Report_content_text_01": "Visita al inmueble y elaboración de informe oficial realizado por un técnico qualificado de Barna-Tasa",
	"Report_content_text_02": "Identificación y localización. Características del inmueble. Datos catastrales y registrales",
	"Report_content_text_03": "Fotografías y croquis del inmueble",
	"Report_content_text_04": "Estudio de mercado real, selección de muestras y cálculo de valores del informe",
	"Report_date": "Fecha del informe",
	"Report_language": "Idioma del informe",
	"Requesting": "Solicitando",
	"Report_number": "Nº de informe",
	"Report_title": "Título del informe",
	"Report_title_missing_error_text": "Falta el título del informe",
	"Representative": "Representante",
	"representative_sample": "muestra representativa",
	"Representative_sample": "Muestra representativa",
	"Representative_TIN": "NIF del representante",
	"Request_a_quote": "Solicitar presupuesto",
	"Request_a_quote_24h": "Solicite presupuesto (24h)",
	"Request_a_quote_here": "Solicite presupuesto aquí",
	"Request_a_quote_for_an_appraisal": "Solicitar presupuesto de tasación",
	"Request_successfully_sent": "Solicitud correctamente enviada",
	"Required_fields": "Campos requeridos",
	"Residual_depreciation": "Depreciación residual",
	"Residual_value": "Valor residual",
	"Restaurants": "Restaurantes",
	"Restricted": "Restringido",
	"Right_of_use": "Derecho de uso",
	"Right_of_use_value": "Valor del derecho de uso",
	"rights": "derechos",
	"Rights": "Derechos",
	"Rigor": "Rigor",
	"Risk_premium": "Prima de riesgo",
	"Riskfree_rate": "Tasa libre de riesgo",
	"Room": "Habitación",
	"Rooms": "Habitaciones",
	"Sat.": "Sáb.",
	"Save": "Guardar",
	"Save_and_go_back": "Guardar y volver",
	"Save_valuation": "Guardar tasación",
	"Search_radius_km": "Radio de búsqueda (km)",
	"Security": "Seguridad",
	"Selected_comparables": "Comparables seleccionados",
	"Send_to_bde_q": "¿Enviar al BdE?",
	"Services": "Servicios",
	"Services_text_01": "BARNA-TASA, S.A. es una sociedad especializada en la VALORACIÓN DE BIENES, homologada y registrada en el Banco de España 'con el número 4.470 en el Registro Oficial de Entidades de Tasación. Nuestra experiencia se basa en más de 30 años de ejercicio profesional en el ámbito de tasaciones, valoraciones y peritajes de la construcción",
	"Services_text_02": "Nuestro principal servicio se enmarca en el campo de las valoraciones y tasaciones con todas las finalidades. También ofrecemos un abanico de servicios relacionados con el mundo de la arquitectura y el peritaje, desde la elaboración de dictámenes y peritajes de construcción hasta certificados, cédulas y levantamientos de planos",
	"Services_text_03": "Realizamos tasaciones para todas las finalidades. Ofrecemos dos tipos de tasaciones según su finalidad",
	"Services_text_04": "La tipología habitual de bienes inmuebles y derechos que valoramos mediante el correspondiente informe de tasación es la siguiente",
	"Services_text_05": "Aceptación del encargo y entrega de documentación necesaria",
	"Services_text_06": "Visita al inmueble por parte de un técnico de BARNA-TASA",
	"Services_text_07": "Elaboración del informe o informes por parte de BARNA-TASA",
	"Services_text_08": "Entrega del informe en formato digital y / o papel",
	"Sign_Up": "Regístrate",
	"Source": "Fuente",
	"Sports_clubs": "Clubs deportivos",
	"Sports_facilities": "Instalaciones deportivas",
	"Staircase": "Escalera",
	"Standard_deviation_of_the_sample": "Desviación estándar de la muestra",
	"Storerooms": "Trasteros",
	"Street_name": "Nombre de vía",
	"Street_number": "Nº vía",
	"Structure": "Estructura",
	"Sun.": "Dom.",
	"Supervisor": "Supervisor",
	"Surnames": "Apellidos",
	"Surnames_name": "Apellidos, Nombre",
	"Surroundings": "Entorno",
	"Surveying": "Levantamiento de planos",
	"Swimming_pool": "Piscina",
	"Tasks": "Tareas",
	"Taxes": "Impuestos",
	"technical_values": "valores técnicos",
	"Technical_values": "Valores técnicos",
	"Technology": "Tecnología",
	"Team_text": "La sociedad está formada por un grupo de arquitectos, ingenieros y especialistas en tasaciones con un amplio conocimiento del mercado inmobiliario y con una experiencia contrastada de más de 30 años en el campo de la valoración inmobiliaria",
	"Teamwork": "Trabajo en equipo",
	"Telephone": "Teléfono",
	"Telephone_contact": "Teléfono de contacto",
	"telephone_number": "nº de telèfon",
	"Telephone_number": "Nº de Teléfono",
	"Telephone_numbers": "Números de teléfono",
	"Tenant_age_years": "Edad del arrendatario",
	"Tenant_remaining_life_expectancy_years": "Vida restante estimada arrendatario",
	"Terrain": "Terreno",
	"Testamentary_shares": "Participaciones testamentarias",
	"The_company": "La Empresa",
	"The_page_contains_unsaved_changes": "La página actual contiene cambios no guardados",
	"The_passwords_do_not_match": "Las contraseñas no coinciden",
	"thousand": "mil",
	"thousand_euros": "mil euros",
	"thousands_of_euros": "miles de euros (€)",
	"Thu.": "Jue.",
	"to": "a",
	"Total_depreciation": "Depreciación total",
	"Total_value": "Valor total",
	"total_values": "valores totales",
	"Total_values": "Valores totales",
	"Trust": "Confianza",
	"Others": "Otros",
	"TIN": "NIF / CIF",
	"Title": "Título",
	"Title_and_date_of_report": "Título y fecha del informe",
	"Title_s_Honorific": "Título / Tratamiento",
	"Transparency": "Transparencia",
	"type": "tipo",
	"Type": "Tipo",
	"Type_here_to_filter_paginated_data": "Escribe aquí para filtrar los datos paginados",
	"Type_of_property": "Tipo de inmueble",
	"Typical_deviation": "Desviación típica",
	"Typology": "Tipología",
	"Uncovered_outdoor_area": "Superficies exteriores descubiertas",
	"Unit_price": "Precio unitario",
	"Unit_value": "Valor unitario",
	"universal_sample": "muestra universal",
	"Universal_sample": "Muestra universal",
	"Updated_reversion_value": "Valor de reversión actualizado",
	"Update_type": "Tipo de actualización",
	"Update_value": "Valor de actualización",
	"Update_value_calculation": "Cálculo del valor de actualización",
	"Upper_limit": "Límite superior",
	"Url": "Link",
	"Useful_life": "Vida útil",
	"Usufruct": "Usufructo",
	"Usufruct_value": "Valor del usufructo",
	"Usufructuary_age_years": "Edad del usufructuario",
	"Urban_planning_parameters": "Parámetros urbanísticos",
	"valuated_in_this_report": "valorados en este informe",
	"Valuation": "Tasación",
	"Valuation_pricing": "Tarifas de tasación",
	"valuations": "valoraciones",
	"Valuation_date": "Fecha del valor de tasación",
	"Valuation_purpose": "Finalidad de la valoración",
	"Valuation_report": "Informe de valoración",
	"Valuation_type": "Tipo de tasación",
	"Value_date": "Fecha del valor",
	"Version": "Versión",
	"VAT": "IVA",
	"Visits": "Visitas",
	"Warnings": "Advertencias",
	"We_are_sorry_c_the_page_you_requested_cannot_be_found": "Lo sentimos, no podemos encontrar la página solicitada",
	"Weighing": "Ponderación",
	"Welcome_message": "Bienvenido a la App de Barnatasa",
	"What_you_need_to_provide": "Qué necesitas aportar?",
	"with": "con",
	"without_saving": "sin guardar",
	"Workflow": "Flujo de trabajo",
	"Wrong_date_message": "La fecha es incompleta o incorrecta",
	"years": "años",
	"You_are_about_to_delete": "Se eliminará",
	"Registry_area": "Superficie Registral",
	"Checked_area": "Superficie comprobada",
	"Plot_occupation": "Ocupación del solar",
	"Plot_free_area_usage": "Uso de la superficie libre del solar",
	"Floors_number_underground": "Nª de plantas bajo rasante",
	"Floors_number_overground": "Nº de plantas sobre rasante",
	"Parking_slots_included_in_appraisal_number": "Nº de plazas de garaje incluidas en la valoración",
	"Entrance_hall": "Portal",
	"Doorman_space": "Portería",
	"Community_room": "Sala comunitaria",
	"Storage_room_included_in_appraisal": "Trastero incluido",
	"Community_parking": "Garaje",
	"Facilities_others": "Otros",
	"Floors_usage_underground": "Uso bajo rasante",
	"Floors_usage_overground": "Uso sobre rasante",
	"Groundfloor_usage": "Uso planta baja",
	"Real_estates_useful_life": "Vida útil del inmueble",
	"Real_estates_total_useful_life": "Vida útil total del inmueble",
	"Remaining_useful_life_years": "Años restantes de vida útil",
	"Urban_and_surroundings_text": "Urbanismo y entorno",
	"Communications": "Comunicaciones",
	"Airport": "Aeropuerto",
	"Harbour": "Puerto",
	"Train": "Tren",
	"Public_transport": "Transporte público",
	"Urban_underground": "Urbano subterráneo",
	"Interurban": "Interurbano",
	"Territorial_feature": "Característica territorial",
	"Income_level": "Nivel de la renta",
	"Homogeneity_feature": "Rasgos de homogeneidad",
	"Main_uses": "Usos dominantes",
	"Density": "Densidad",
	"Accessibility": "Accesibilidad",
	"Consolidation_degree": "Grado de consolidación",
	"Occupation_degree": "Grado de ocupación",
	"Evolution": "Evolución",
	"Average_age": "Antigüedad característica",
	"Commercial": "Comercial",
	"Educational": "Educacional",
	"Public_parking": "Aparcamiento público",
	"Medical_assistance": "Asistencia médica",
	"Leisure": "Ocio",
	"Building_development_level": "Nivell de desenvolupament de l'edificació",
	"Facilities": "Equipamientos",
	"MUC_map": "Mapa del MUC",
	"Registry": "Registro",
	"Section": "Sección",
	"Volume": "Tomo",
	"Book": "Libro",
	"Page": "Página",
	"Registry_real_estate_number": "Nº de finca registral",
	"Holder": "Titular",
	"Property_coef": "Coeficiente de propiedad",
	"Bedrooms_and_bathrooms": "Dormitorios y baños",
	"Covered_outdoor_areas": "Superficies exteriores cubiertas",
	"Uncovered_outdoor_areas": "Superficies exteriores descubiertas",
	"Add_covered_outdoor": "Añadir espacio exterior cubierto",
	"Add_uncovered_outdoor": "Añadir espacio exterior descubierto",
	"Enclosed_area": "Superficie cerrada",
	"Enclosed_checked_area": "Superficie cerrada comprobada",
	"Low_enclosed_checked_area_error_text": "La superficie cerrada comprobada es inferior a la superficie total útil",
	"Proportional_part_of_common_elements": "Parte proporcional de elementos comunes",
	"Common_elements_cadastral_area": "Elementos Comunes Catastro",
	"Common_elements_registry_area": "Elementos Comunes Registro",
	"Common_elements_checked_area": "Elementos Comunes Comprobada",
	"Common_elements_adopted_area": "Elementos Comunes Adoptada",
	"Total_areas_summary_table": "Resumen de superficies totales",
	"Register": "Registro",
	"Cadaster": "Catastro",
	"Checked": "Comprobada",
	"Selected": "Seleccionada",
	"Adopted": "Adoptada",
	"Usage": "Uso",
	"Covered_outdoors_area": "Superficie espacios cubiertos exteriores",
	"Uncovered_outdoors_area": "Superiície espacios descubiertos exteriores",
	"Built_plus_common_elements_area": "Superficie Construida + Elem. Com.",
	"Built_plus_common_elements": "Construida + Elem. Com.",
	"Common_elements": "Elementos comunes",
	"Number_of_rooms_to_exterior": "Nº de habitaciones exteriores",
	"Day_night_zoning": "Zonificación día / noche",
	"Door_opener": "Portero automático",
	"Fitted_cupboards": "Armarios empotrados",
	"Gas": "Gas",
	"Sanitary_fittings": "Aparatos sanitarios",
	"Taps": "Grifería",
	"Hot_water": "Agua caliente",
	"Fire_prevention": "Prevención al fuego",
	"Intrusion_prevention": "Prevención al intrusismo",
	"Foundation": "Cimentación",
	"Roof": "Cubierta",
	"External_enclosures": "Cerramientos exteriores",
	"Insulation": "Aislamiento",
	"External_carpentry": "Carpintería exterior",
	"Glazing": "Acristalamiento",
	"Views": "Vistas",
	"Windows_size_and_quantity": "Dimensión y cantidad de ventanas",
	"Noise_facade": "Nivel de ruido en fachada",
	"Systems": "Instalaciones",
	"conservation_status": "estado de conservación",
	"Building_shell": "Envolvente del edificio",
	"building_shell": "envolvente del edificio",
	"Shell": "Envolvente",
	"shell": "envolvente",
	"Interior_finishes": "Acabados interiores",
	"Living": "Estar",
	"Kitchen": "Cocina",
	"Walls": "Paredes",
	"Ceilings": "Techos",
	"Interior_carpentry": "Carpintería interior",
	"Circulations": "Circulaciones",
	"BdE_files": "Fichas BdE",
	"Construction_prices": "Costes de construcción",
	"Add_bec_property": "Añadir tipo de inmueble",
	"Add_bec_number": "Añadir nº B.E.C.",
	"Year": "Año",
	"Quarter": "Trimestre",
	"Bec_adjustment_coef": "Coeficiente de ajuste del B.E.C.",
	"Adjusted_bec_price": "Precio ajustado del B.E.C.",
	"Expenses_and_industrial_benefit_bec_pct": "Porcentaje de Gastos y Beneficio Industrial",
	"Construction_status": "Estado de construcción",
	"Construction_cost_notes": "Observaciones sobre el coste de construcción",
	"Mandatary": "Mandatario",
	"Mandatary_entity": "Entidad mandataria",
	"Acc_mortgage_market_law_q": "Sigue la ley del mercado hipotecario?",
	"Acc_eco_decree_q": "Sigue la orden ECO/805/2003?",
	"location": "localización",
	"Registry_property": "Finca registral",
	"Cadastral_file": "Ficha Cadastral",
	"Nucleus_area": "Superficie del municipio",
	"Nucleus_type": "Tipo de núcleo",
	"Locality": "Localidad",
	"Employment_occupation": "Ocupación laboral",
	"Population": "Población",
	"Population_density": "Densidad de población",
	"Population_growth": "Crecimiento de población",
	"Last_year": "Último año",
	"Terrain_description": "Descripción del terreno",
	"Terrain_infrastructures": "Infraestructuras del terreno",
	"Execution": "Ejecución",
	"Water_supply": "Suministro de agua",
	"Terrain_area": "Superficie del terreno",
	"Site_quality": "Calidad del emplazamiento",
	"Underground_levels": "Niveles bajo rasante",
	"Ground_level": "Nivel rasante",
	"Overground_levels": "Niveles sobre rasante",
	"Building_description": "Descripción de la edificación",
	"Checkings_realized": "Comprobaciones realizadas",
	"Documents_used": "Documentación utilizada",
	"Interior_visit": "Visita interior del inmueble",
	"Expropriation_procedure": "Procedimiento de expropiación",
	"Expropriation_plan": "Plan o proyecto de expropiación",
	"Expropriation_admin_ruling": "Resolución administrativa expropiació",
	"Expropriation_file": "Expediente de expropiación",
	"Occupancy": "Estado de ocupación y uso",
	"Servitudes": "Servidumbres",
	"Public_protection_regime": "Régimen de protección pública",
	"Urban_paramaters_suitability": "Adecuación al planeamiento urbanístico",
	"Another": "Otra",
	"Approved_project_by_professional_association": "Proyecto visado por el colegio profesional",
	"Cadastral_documents": "Documentación catastral",
	"Construction_license": "Licencia de construcción",
	"Construction_last_certificate": "Último certificado de construcción",
	"Construction_contract": "Contrato de construcción",
	"Occupancy_status": "Estado de ocupación",
	"Photographic_report": "Reportaje fotográfico",
	"Property_sketch": "Croquis del inmueble",
	"Property_titles": "Documento de propiedad según normativa",
	"Situation_plan": "Plano de situación",
	"Ten_year_insurance": "Seguro decenal",
	"Urban_plan": "Plano urbanístico",
	"Habitability_conditions": "Condiciones de habitabilidad",
	"Main_orientation": "Orientación principal",
	"Property_title": "Título de propiedad",
	"Usage_assigned": "Uso asignado",
	"Usage_assigned_by_the_owner": "Uso asignado por la propiedad",
	"Inspection_realized": "Comprobación realizada",
	"Economical_activity": "Actividad económica",
	"Real_rights": "Derechos reales",
	"Bulletin_number": "Nº de Boletín",
	"a": "un",
	"Select": "Seleccionar",
	"Market_data": "Datos de mercado",
	"Market_samples": "Muestras de mercado",
	"Offer_date": "Fecha de la oferta",
	"Sample": "Muestra",
	"Market_analysis": "Análisis de mercado",
	"Prices_estimated_yearly_evolution_pct": "Precios - evolución anual, variación estimada (%)",
	"Market_value_evolution_probability_pct": "Previsión evolución del valor de comparación (%)",
	"Offer_production": "Oferta - producción",
	"Offer_yearly_stock": "Oferta - Stock anual",
	"Offer_trend": "Oferta - tendencia",
	"Demand_level": "Demanda - nivel",
	"Demand_speed_of_sales": "Demanda - velocidad de ventas",
	"Demand_trend": "Demanda - tendencia",
	"Prices_expectancy": "Precios - Expectativa",
	"Prices_past_cicles_volatility": "Expectativa - Volatilidad de ciclos pasados",
	"Market_conjuncture": "Coyuntura de mercado",
	"Market_value_reduction_probability_expectancy": "Expectativa - Probabilidad de reducción del valor de comparación",
	"Offer": "Oferta",
	"Demand": "Demanda",
	"Expectation": "Expectativa",
	"Maximum": "Máximo",
	"Minimum": "Mínimo",
	"Mean": "Media",
	"Median": "Mediana",
	"Market_prices": "Precios del mercado",
	"Neighbourhood": "Barrio",
	"Situation": "Situación",
	"Samples": "Muestras",
	"Similarities": "Similitudes",
	"Statistical_deviations": "Desviaciones estadísticas",
	"Typical_deviation_of_the_sample": "Desviación típica de la muestra",
	"Technical_values_calculation": "Cálculo de valores técnicos",
	"Material_execution_cost_as_new": "Coste de ejecución material a nuevo",
	"Finished_building_market_value": "Valor de mercado edificio acabado",
	"finished_building": "inmueble acabado",
	"Total_values_calculation": "Cálculo de valores totales",
	"year": "año",
	"Other_values": "Otros valores",
	"Appraisal_value_determination_text": "De acuerdo con los criterios establecidos en la orden ECO 805/2003, el valor aplicable es el siguiente:",
	"Add_constraint": "Añadir condicionante",
	"Add_warning": "Añadir advertencia",
	"Add_note": "Añadir observación",
	"Constraints": "Condicionantes",
	"Constraints_foreseen_by_law": "Condicionantes previstos por Ley",
	"Warnings_foreseen_by_law": "Advertencias previstas por Ley",
	"Notes_foreseen_by_barnatasa": "Observaciones previstas por BARNA-TASA S.A.",
	"English": "Inglés",
	"Spanish": "Castellano",
	"The_Real_Estate_is_not_protected": "El inmueble no está protegido",
	"The_Real_Estate_is_not_rented_or_ceded": "El inmueble no está alquilado o cedido",
	"There_is_no_cession_of_the_right_of_use": "El derecho de uso del inmueble no está cedido",
	"The_value_is_not_calculated": "El valor no se calcula",
	"Elements_included_in_this_valuation": "Elementos incluidos en esta valoración",
	"Market_value_adjustment_pct": "Porcentaje de ajuste del valor de mercado",
	"Constraint": "Condicionante",
	"Warning": "Advertencia",
	"Note": "Observación",
	"Upload_photographs": "Cargar fotografías",
	"Photograph": "Fotografía",
	"Photographs": "Fotografías",
	"Image_footer": "Pie de imagen",
	"Upload_files": "Cargar archivos",
	"File_name": "Nombre del archivo",
	"in": "en",
	"Registry_Documents": "Documentos Registrales",
	"Cadastral_Documents": "Documentos Catastrales",
	"Plans": "Planos",
	"Sketches": "Croquis",
	"Cession_Documents": "Documentos de Cessión",
	"Contracts": "Contratos",
	"Other_Documents": "Otros Documentos",
	"with_date": "con fecha",
	"Date_of_issue": "Fecha de emisión",
	"Signatures": "Firmas",
	"Report_date_of_issue": "Fecha de emisión del informe",
	"Professional_that_visited_the_property": "Técnico que realizó la visita",
	"Date_of_visit": "Fecha de la visita",
	"Appraisers": "Tasadores",
	"Supervisors": "Supervisores",
	"Appraisers_Index": "Índice de Tasadores",
	"Supervisors_Index": "Índice de Supervisores",
	"Add_appraiser": "Añadir tasador",
	"Add_supervisor": "Añadir supervisor",
	"Visit_date": "Fecha de la visita",
	"Technician_who_performed_the_visit": "Técnico visita",
	"Visit": "Visita",
	"Floor_name": "Nombre de planta",
	"Import_comparable_set": "Importar conjunto de comparables",
	"Import_comparable_set_from_another_market_study": "Importar conjunto de comparables from another market study",
	"There_are_unsaved_changes": "Existen cambios no guardados",
	"Unsaved_data_will_be_lost": "Se perderán los datos no guardados",
	"Cover": "Portada",
	"Annexed_documents": "Documentos anexos",
	"Photographies": "Fotografías",
	"Report_of": "Informe de",
	"correlated_pages_numbered_from": "páginas correlativas, numerades de ",
	"technician": "técnico",
	"Sanitary_fittings_quality": "Calidad aparatos sanitarios",
	"Taps_quality": "Calidad grifería",
	"Land_selected_area": "Método de selección",
	"Urban_parameters_suitability": "Adecuación al plan urbanístico",
	"Maps": "Mapas",
	"Situation_maps": "Mapas de situación y emplazamiento",
	"Other": "Otra",
	"Subsidy_status": "Calificación de protección pública",
	"Quote": "Presupuesto",
	"Appraisal_quote": "Presupuesto de tasación",
	"Appraisal_quotes": "Presupuestos de tasación",
	"Add_appraisal_quote": "Añadir presupuesto de tasación",
	"Title_and_date_of_quote": "Título y fecha del presupuesto",
	"valuated_in_this_quote": "valorados en este presupuesto",
	"Quote_title_missing_error_text": "Falta el título del presupuesto",
	"Print_quote_in_PDF": "Imprimir presupuesto en PDF",
	"Create_new_real_estate": "Crear nuevo inmueble",
	"Select_Real_estate_to_be_added": "Selecciona inmueble a añadir",
	"Existing_Real_estates": "Inmuebles existentes en la base de datos",
	"create_a_new_one": "crea uno nuevo",
	"staircase": "escalera",
	"block": "bloque",
	"door": "puerta",
	"Full_address": "Dirección completa",
	"Status": "Estado",
	"Quote_number": "Nº de presupuesto",
	"Quote_content": "Contenido del presupuesto",
	"Quote_title": "Título del presupuesto",
	"Travel_expenses": "Gastos de desplazamiento",
	"Travel_one_way_hours": "Horas de viaje (ida)",
	"Travel_both_ways_hours": "Horas de viaje (ida y vuelta)",
	"Travel_fees_per_hour": "Honorarios por hora de viaje",
	"Total_car_expenses_one_way": "Gastos de gasolina y peajes (ida)",
	"Total_car_expenses_both_ways": "Gastos totales de gasolina y peajes (ida y vuelta)",
	"Total_travel_fees": "Gastos totales por desplazamiento",
	"Quote_area_average_unit_price": "Media de precios de la zona (€/m2)",
	"Quote_base_fees": "Honorarios base",
	"Quote_excess_pct": "% del exceso de honorarios base",
	"Quote_base_price": "Honorarios finales",
	"Quote_base_price_coef": "Coeficiente de ajuste",
	"Valuation_quote": "Presupuesto de tasación",
	"Appraisal_cost": "Coste de tasación",
	"Appraisal_fees": "Honorarios de tasación",
	"Appraisal_price": "Precio de tasación",
	"hours": "horas",
	"Area_prices": "Precios de la zona",
	"Area_average_unit_price": "Precio medio de la zona",
	"Ads_date_range": "Rango de fechas de los anuncios",
	"Current_area_prices": "Precios actuales de la zona",
	"pre_appraisal": "pre-tasación",
	"Pre_appraisal": "Pre-tasación",
	"Estimated_built_area": "Superficie construida estimada",
	"Pre_appraisal_value": "Valor de pre-tasación",
	"Area_average_price_coef": "Coeficiente de ajuste del precio",
	"Adopted_area_average_price": "Precio unitario adoptado",
	"Car_fuel_expenses_one_way": "Coste Gasolina (ida)",
	"Car_fuel_expenses_both_ways": "Coste Gasolina (ida y vuelta)",
	"Car_toll_expenses_one_way": "Coste Peajes (ida)",
	"Car_toll_expenses_both_ways": "Coste Peajes (ida y vuelta)",
	"Valuation_pricing_info_table": "Tabla de precios de tasación",
	"Check_prices": "Buscar precios",
	"Add_ad_manually": "Añadir nuevo anuncio manualmente",
	"Ads_index": "Índice de anuncios",
	"Go_back_to_market_study": "Volver al estudio de mercado",
	"Offer_price_reduction_coef": "Coeficiente reductor del precio",
	"Cession_files": "Documentps de arrendamiento",
	"Lease": "Arrendamiento",
	"Gross_tax_per_1000_inhabitants": "Tasa bruta por cada 1.000 habitantes",
	"Site": "Emplazamiento",
	"Urban_planning": "Urbanismo",
	"Construction_description": "Descripción de la construcción",
	"Status_on_occupancy_protection_cession_usage_and_real_rights": "Estado de ocupación, régimen de protección, cesión, uso y derechos reales",
	"Real_rights_protection_and_occupation": "Derechos reales, protección y ocupación",
	"PA_number": "Nº de colegiado",
	"Quote_petitioner": "Solicitante del presupuesto",
	"Quote_petitioners": "Solicitantes de presupuesto",
	"Dear": "Estimado",
	"Dear_m": "Estimado",
	"Dear_f": "Estimada",
	"Quote_sentence_01": "Nos place adjuntar presupuesto de honorarios para el Informe de Tasación de los seguientes inmmuebles:",
	"Approx_area": "Superficie aprox.",
	"Signed": "Firmado",
	"Amount_money": "Importe",
	"Total_cost_including_VAT": "Coste total (IVA incluïdo)",
	"Fiscal_parameters": "Parámetros fiscales",
	"VAT_pct": "IVA (%)",
	"Quote_sentence_02": "Se realizará pago del 50% al inicio del trabajo y el 50% restante a la entrega de los Informes de Tasación",
	"Quote_sentence_03": "Abonar en cuenta bancaria de BARNA-TASA, S.A.",
	"Quote_sentence_04": "Tareas a realizar para confecccionar los informes de tasación",
	"Quote_sentence_05": "Visita a los inmuebles por un técnico Arquitecto o Ingeniero de BARNA-TASA",
	"Quote_sentence_06": "Elaboración del informe. Contenido",
	"Payment_details": "Detalles de pago",
	"Required_documentation": "Documentación necesaria",
	"Quote_sentence_07": "Entrega de los informes en formato digital (PDF)",
	"Quote_sentence_08": "Si se requiere de entrega en papel (opcional) se aplicará un coste adicional de 15 € en concepto de impresión y envío",
	"Quote_sentence_09": "Nombre, NIF y dirección del solicitante",
	"Quote_sentence_10": "Nombre NIF y dirección fiscal para la factura",
	"Quote_sentence_11": "Copia completa de la escritura o de la nota registral",
	"Quote_sentence_12": "Copia del IBI (datos Catastrales) (opcional)",
	"Quote_sentence_13": "Copia del contrato de alquiler y un recibo actualizado si se trata de un inmueble en alquiler",
	"Quote_sentence_14": "Finalidad de la tasación (adquisición o venta, constituir garantías hipotecarias, expropiación...)",
	"Quote_sentence_15": "Nombre y teléfono de la persona de contacto para visitar la finca",
	"Quote_sentence_16": "Planos de la finca (opcional)",
	"At_your_disposal_for_any_clarification": "A su disposición para cualquier acalaración",
	"Kindest_regards": "Reciba nuestra cordial salutación",
	"CFO_CHRO_female": "Directora de Finanzas y Recursos Humanos",
	"Additional_costs": "Otros importes",
	"Quote_sentence_17": "En el caso de ser necessaria la assistencia del técnico en el juzgado para la ratificación del informe el coste será de 150 € + IVA",
	"Quote_sentence_18": "La entrega del informe se hará en formato digital (PDF). En el caso de requerirse la entrega del informe en papel, el coste será de 15 € en concepto de impresión y envío",
	"Appraisal_invoice": "Factura",
	"Appraisal_invoices": "Facturas",
	"Add_appraisal_invoice": "Añadir factura",
	"Title_and_date_of_invoice": "Título y fecha de factura",
	"valuated_in_this_invoice": "valorados en esta factura",
	"Invoice_title_missing_error_text": "Falta el título de la factura",
	"Print_invoice_in_PDF": "Imprimir factura en PDF",
	"Valuation_invoice": "Factura",
	"Invoice": "Factura",
	"Client": "Cliente",
	"Invoice_number": "Nº de factura",
	"Invoice_content": "Contenido de la factura",
	"Invoice_title": "Título de la factura",
	"Add_petitioner": "Añadir solicitante",
	"Create_new_contact": "Crear nuevo contacto",
	"No_petitioners_text": "No se ha añadido ningún contacto en la lista de solicitantes. Seleccione un contacto de la lista y haga click en 'añadir solicitante''",
	"Surnames_name_or_company": "'Apellidos, Nombre' o 'Nombre de la empresa'",
	"No_records": "No existen registros",
	"Quotes_requested_by": "Presupuestos solicitados por",
	"Dear_sir_or_madam": "Querido Sr. / Sra.",
	"Dear_sirs_or_madams": "Queridos Sres. / Sras.",
	"Dear_sir": "Querido senyor",
	"Dear_madam": "Querida senyora",
	"Dear_sirs": "Queridos señores",
	"Dear_madams": "Queridas señoras",
	"Dear_madams_and_sirs": "Queridas señoras y señores",
	"Dear_madam_and_sir": "Querida señora y señor",
	"Dear_pl": "Queridos",
	"Dear_pl_f_m": "Queridas y queridos",
	"Dear_pl_f": "Queridas",
	"Dear_pl_m": "Queridos",
	"Main_email": "Dirección de E-mail principal",
	"Add_other_email": "Añadir e-mail adicional",
	"Complete_name": "Nombre completo",
	"Payment_conditions": "Condiciones de pago",
	"Note_w": "Nota",
	"Final_price": "Precio final",
	"Discount_pct": "Descuento (%)",
	"Discount_notes": "Nota sobre el descuento",
	"Bank_name": "Nombre del banco",
	"Court_assistance_fees": "Honorarios assistencia juicio",
	"Required_docs": "Documentación necessaria",
	"Documentation_type": "Tipo de documentación",
	"Add_required_doc": "Añadir en la lista",
	"Document": "Documento",
	"Petitioners_missing_error_text": "Falta añadir el solicitante de presupuesto",
	"Realestates_missing_error_text": "Falta añadir los inmuebles del presupuesto",
	"Requireddocs_missing_error_text": "Falta añadir la documentación necesaria",
	"Discount": "Descuento",
	"Fees_incl_discount": "Honorarios con descuento",
	"Quote_reference": "Presupuesto asociado a la factura",
	"Invoice_lines": "Linias de factura",
	"Add_invoice_line": "Añadir linia de factura",
	"Units": "Unidades",
	"Import_quote_concepts": "Importar conceptos del presupuesto",
	"invoice": "factura",
	"line": "linia",
	"Lines_missing_error_text": "Falta introducir los conceptos de la factura",
	"Concept": "Concepto",
	"Add_client": "Añadir cliente",
	"Appraisal_invoice_description": "Descripción de la factura",
	"Invoice_to": "Factura a",
	"Emited_by": "Emitida por",
	"Invoice_Total": "Total Factura",
	"Emmission_date": "Fecha de emisión",
	"Reference": "Referencia",
	"Appraisal_invoices_index": "Índice de facturas",
	"Appraisal_quotes_index": "Índice de presupuestos",
	"Invoice_fiscal_number": "Nº fiscal de factura",
	"Billing": "Facturación",
	"invoice_fiscal_number": "nº fiscal de factura",
	"Last_m": "Último",
	"invoice_number": "nº de factura",
	"Last_created_invoice": "Última factura creada",
	"Welcome": "Bienvenido",
	"Ad_description": "Descripción del anuncio",
	"Upload_to_database": "Guardar e incorporar a la base de datos",
	"Address_referral": "Dirección de referencia",
	"Max_distance": "Distancia máx.",
	"Print_report_s_certificate_in_PDF": "Imprimir informe/certificado en PDF",
	"Appraisal_certificate": "Certificado de tasación",
	"Certificate_text_01": "Ferran López-Doriga Fontcuberta, Arquitecto Superior, en calidad de Director y Supervisor de Tasaciones de BARNA-TASA, S.A., inscrita en el Registro Oficial de Sociedades de Tasación del Banco de España, con el nº 4.470 y fecha de inscripción 26 de Junio de 1.995,",
	"Certificate_text_02": "Que con el número de Expediente",
	"Certificate_text_03": "se ha efectuado un informe de tasación con fecha<",
	"Certificate_text_04": "y la tasación consta en resumen de los siguientes datos",
	"Certificate_text_05": "Para que conste a los efectos oportunos, firmo el presente certificado en Barcelona, ",
	"certifies": "certifica",
	"Petitioner_TIN": "NIF del solicitante",
	"Petitioner_address": "Dirección del solicitante",
	"registered_in": "inscrita en",
	"from_the": "del",
	"Method_used_to_calculate_the_value": "Método utilizado para calcular el valor adoptado",
	"Cost_value_current_state": "Valor del Coste a estado actual",
	"Comparison_value": "Valor de Comparación",
	"Maximum_legal_value": "Valor Máximo Legal",
	"Adjusted_market_value": "Valor de Mercado Ajustado",
	"Total_appraisal_value": "Valor total de tasación",
	"Real_estates_missing_error_text": "Falta añadir los inmuebles que conforman el informe de tasación",
	"Sign_quote": "Firmar presupuesto",
	"Sign_appraisalreport": "Firmar informe de tasación",
	"Appraiser_sign_appraisalreport": "Firmar informe (Tasador)",
	"Supervisor_sign_appraisalreport": "Firmar informe (Supervisor)",
	"Sign_invoice": "Firmar factura",
	"Sign_certificate": "Firmar certificado",
	"Signature": "Firma",
	"Appraisers_signature": "Firma del Tasador",
	"Supervisors_signature": "Firma del Supervisor",
	"Main_telephonenumber": "Nº de teléfono principal",
	"with_purpose": "con finalidad",
	"Purpose": "Finalidad",
	"Prices": "Precios",
	"Urban_Planning_Documents": "Documentos Urbanísticos",
	"BEC_expenses_plus_builders_benefit_pct": "% de gastos y beneficio del promotor en el precio del BEC",
	"pkg_number": "Nº de plaza",
	"Index": "Índice",
	"Cession_type": "Tipo de cesión",
	"Real_right_type": "Tipo de rerecho real",
	"Reports": "Informes",
	"Other_files": "Otros documentos",
	"Construction_reposition_cost_as_new": "Coste de reposición de la construcción a nuevo",
	"Construction_value_in_actual_state": "Valor de la construcción a estado actual",
	"executed_construction": "construcción realizada",
	"Integrity": "Integridad",
	"remaining": "restante",
	"or": "o",
	"Project": "Proyecto",
	"Projects": "Proyectos",
	"Add_project": "Añadir proyecto",
	"Projects_of_the_Real_Estate": "Proyectos",
	"BDE_files_index": "Índice de ficheros del BDE",
	"BDE_files": "Ficheros del BDE",
	"Asset_type": "Tipo de activo",
	"Property_usage": "Uso del inmueble",
	"Parking_spots_included_number": "Nº de plazas de parking incluidas",
	"BdE_appraisal_files": "Tasaciones",
	"BdE_realestate_files": "Inmuebles",
	"BdE_comparable_files": "Comparables",
	"BdE_relationships_files": "Relaciones",
	"Insurance_value_rd_1982_text": "Valor de reemplazamiento bruto excluido el valor del terreno",
	"Insurance_value_rd_2009_text": "Valor de tasación excluido el valor del terreno",
	"VAT_not_included": "IVA no incluido",
	"EEC_conditions": "Viviendas de hasta 100 m² en el Área Metropolitana de Barcelona: 125 €+ IVA",
	"OCC_conditions": "Viviendas de hasta 100 m² en el Área Metropolitana de Barcelona: 125 €+ IVA",
	"EECOCC_conditions": "Viviendas de hasta 100 m² en el Área Metropolitana de Barcelona: 210 €+ IVA",
	"OT_conditions": "Altres tipologies segons pressupost"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/es.json
// module id = 2283
// module chunks = 0